module.exports = __webpack_public_path__ + "r-v3/img/mic_on_blue.82c02d00.svg";